import { combineReducers } from 'redux';

import {
  initProjectRequest,
  initProjectSuccess,
  initProjectFail,
  getProjectRequest,
  getProjectFail,
  getProjectSuccess,
  saveProjectRequest,
  saveProjectFail,
  saveProjectSuccess,
  createProjectRequest,
  createProjectSuccess,
  createProjectFail,
  resetCurrentProject,
  getProjectRefreshSuccess,
} from '../actions';
import { ProjectAction, SelectedProjectState } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof SelectedProjectState> = Reducer<SelectedProjectState, ProjectAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case resetCurrentProject.type:
    case getProjectRequest.type:
    case initProjectRequest.type:
      return null;

    case getProjectSuccess.type:
    case createProjectSuccess.type:
    case saveProjectSuccess.type:
    case initProjectSuccess.type:
    case getProjectRefreshSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getProjectRequest.type:
    case createProjectRequest.type:
    case saveProjectRequest.type:
    case initProjectRequest.type:
      return true;

    case getProjectSuccess.type:
    case getProjectFail.type:
    case createProjectSuccess.type:
    case createProjectFail.type:
    case saveProjectSuccess.type:
    case saveProjectFail.type:
    case initProjectSuccess.type:
    case initProjectFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case initProjectFail.type:
    case getProjectFail.type:
      return true;

    case initProjectSuccess.type:
    case getProjectSuccess.type:
    case resetCurrentProject.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<SelectedProjectState>({
  data,
  loading,
  error,
});
